import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { UsuarioService } from '@services/usuario/usuario.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { UsuarioDto } from '@models/usuario/usuarioDto.model';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { BreakpointObserver } from '@angular/cdk/layout';
import { PersonaService } from '@services/persona/persona.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { AccionesDialog, Roles } from '@models/base/identificadores.model';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { SinDatosParaMostrarComponent } from '@component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { BtnNuevoUsuarioComponent } from '../btn-nuevo-usuario/btn-nuevo-usuario.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogFormUsuarioComponent } from '../dialog-form-usuario/dialog-form-usuario.component';
import { DialogParams } from '@interfaces/dialogParam.interface.model';
import { EmpresaUsuarioService } from '@services/empresaUsuario/empresaUsuario.service';
import { UsuarioFilter } from '@models/usuario/usuarioFilter.model';
import { EmpresaUsuarioDto } from '@models/empresaUsuario/empresaUsuarioDto.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ButtonNewComponent } from '@component/button-new/button-new.component';
import { StatusBadgeComponent } from '@component/status-badge/status-badge.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonFilterTableClearComponent } from '@component/button-filter-table-clear/button-filter-table-clear.component';
import { ButtonFilterTableComponent } from '@component/button-filter-table/button-filter-table.component';
import { ButtonActionComponent } from '@component/button-action/button-action.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { RolEmpresaService } from '@services/rolEmpresa/rolEmpresa.service';
import { MatSelectModule } from '@angular/material/select';

@Component({
  standalone: true,
  imports: [CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    NgxSpinnerModule,
    AppRolesDirective,
    SinDatosParaMostrarComponent,
    BtnNuevoUsuarioComponent,
    MatCheckboxModule,
    MatSlideToggleModule,
    ButtonNewComponent,
    StatusBadgeComponent,
    ButtonActionComponent,
    MatTooltipModule,
    ButtonFilterTableClearComponent,
    ButtonFilterTableComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatTableModule,
    MatSelectModule,
    NgxSpinnerModule],
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent implements OnInit, AfterViewInit {
  accionesDialog = AccionesDialog;
  formBuilder = new FormBuilder
  formFilter!: FormGroup;
  data = false
  displayedColumns: string[] = [];
  public usuarios: UsuarioDto[] = [];
  dataSource = new MatTableDataSource<EmpresaUsuarioDto>();
  isLoading: boolean = true;
  errorMessage: string = "";
  @ViewChild(MatSort) sort!: MatSort

  isChecked: boolean = false;
  checkedFiltroAvanzado: boolean = false
  roles: any;

  constructor(
    private UsuarioService: UsuarioService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private personaService: PersonaService,
    private empresaUsuarioService: EmpresaUsuarioService,
    private router: Router,
    private dialog: MatDialog,
    private rolEmpresaService: RolEmpresaService
  ) {

    this.formFilter = this.formBuilder.group({
      UserName: [null],
      Nombre: [null],
      Apellido: [null],
      Correo: [null],
      FechaAltaDesde: [null],
      FechaAltaHasta: [null],
      EsActivoEmpresa: [null],
    });

    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ["userName", "accion"] :
        ["userName", "nombreCompleto", "correo", "rol", "estado", "estados", "accion"];
    });


  }

  private paginator!: MatPaginator;

  ;

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }

  ngOnInit(): void {
    this.iniciaFiltroTabla()
    this.getAllRoles();
  }

  iniciaFiltroTabla() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const search = filter.trim().toLowerCase();
      return (
        data.usuario?.userName?.toLowerCase().includes(search) ||
        data.usuario?.nombre?.toLowerCase().includes(search) ||
        data.usuario?.apellido?.toLowerCase().includes(search) ||
        data.usuario?.correo?.toLowerCase().includes(search) ||
        data.rol?.descripcion?.toLowerCase().includes(search)
      );
    }
  }

  guardarFiltro() {
    const filtro: UsuarioFilter = this.formFilter.value;
    localStorage.setItem('filtroUsuarioEmpresaGuardado', JSON.stringify(filtro));
  }

  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroUsuarioEmpresaGuardado');
  }

  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }

  aplicarFiltro(filtro: UsuarioFilter = this.formFilter.value) {
    this.getAllByFilter(filtro);
    this.guardarFiltro();
  }

  applyFilter(event: any) {
    if (event && event.target && event.target instanceof HTMLInputElement) {
      let filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  onRolChange(empresaUsuario: any, nuevoRolId: number) {
    if (empresaUsuario.rol?.id === nuevoRolId) return;

    const payload = {
      idUsuario: empresaUsuario.usuario.id,
      idEmpresa: empresaUsuario.idEmpresa,
      idRol: nuevoRolId
    };

    this.empresaUsuarioService.actualizarRolUsuarioEmpresa(payload.idUsuario, payload.idRol)
      .subscribe(
        data => {
          this.spinner.hide("spRol");
          empresaUsuario.rol.id = nuevoRolId;
          empresaUsuario.rol = this.roles.find((r: { id: number; }) => r.id === nuevoRolId);
        },
        error => {
          this.spinner.hide("spRol");
          this.snackBar.showError(error, "Error");
        });
  }

  getAllRoles() {
    this.spinner.show("spRol");
    this.rolEmpresaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spRol");
          this.roles = data.filter(x => x.id != Roles.SuperAdministradores)
        },
        error => {
          this.spinner.hide("spRol");
          this.snackBar.showError(error, "Error");
        });
  }
  getAllByFilter(filtro: UsuarioFilter) {
    this.spinner.show('spUsuario')
    this.empresaUsuarioService.getAllByFilter(filtro)
      .subscribe(
        data => {
          this.spinner.hide('spUsuario')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spUsuario')
          this.snackBar.showError(error, "Error");
        })
  }


  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.data = data

    switch (accion) {
      case AccionesDialog.Ver:
        dialogConfig.width = "70%"
        break;

      default:
        dialogConfig.width = "50%"
        break;
    }

    const dialogRef = this.dialog.open(DialogFormUsuarioComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Eliminar:
          this.aplicarFiltro()
          break;
        default:

          break;
      }

    });
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = (data: any, filter: string) => {
      let searchTerms = JSON.parse(filter);
      return data.name.toLowerCase().indexOf(searchTerms.userName) !== -1
        && data.estado.toString().toLowerCase().indexOf(searchTerms.activo) !== -1
    }
    return filterFunction;
  }

  sortingDataAccessor() {
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'userName':
          return item.usuario?.userName?.toLowerCase() || '';
        case 'nombreCompleto':
          return `${item.usuario?.nombre || ''} ${item.usuario?.apellido || ''}`.toLowerCase();
        case 'correo':
          return item.usuario?.correo?.toLowerCase() || '';
        case 'rol':
          return item.rol?.descripcion?.toLowerCase() || '';
        case 'estado':
          return item.activo ? 1 : 0; // o true/false si querés mantener orden booleando
        default:
          return item[property];
      }
    };
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.sortingDataAccessor()
  }

}
